import Bar from './Bar';
import FinishButton, { FinishLink, FinishWrapper } from './FinishButton';
import Total, { TotalWrapper } from './Total';

export default { Bar, FinishButton, FinishLink, FinishWrapper, Total, TotalWrapper };
